import { render, staticRenderFns } from "./dynamic_collect.vue?vue&type=template&id=4146cdd3&scoped=true"
import script from "./dynamic_collect.vue?vue&type=script&lang=js"
export * from "./dynamic_collect.vue?vue&type=script&lang=js"
import style0 from "./dynamic_collect.vue?vue&type=style&index=0&id=4146cdd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4146cdd3",
  null
  
)

export default component.exports